/**
 * Solvia header scroll-aware background.
 * scrollY > 10 で `header-component.header` に `header--scrolled` クラス付与、
 * transparent header を var(--color-8-gray, #eaeaea) 背景に遷移。
 *
 * Atelier `header.js` の data-scroll-direction (sticky show/hide) とは独立。
 * solvia-scroll-trigger.js (per-element IntersectionObserver) とも別実装。
 */
(() => {
  if (typeof window === 'undefined') return;
  const header = document.querySelector('header-component.header');
  if (!header) return;
  const announcementSelector = '.solvia-free-shipping-announcement[data-sticky-with-header="true"]';
  const updateAnnouncementHeight = () => {
    const announcement = document.querySelector(announcementSelector);
    document.documentElement.style.setProperty(
      '--solvia-announcement-height',
      `${announcement?.getBoundingClientRect().height ?? 0}px`
    );
  };
  const announcementObserver = new ResizeObserver(updateAnnouncementHeight);
  const observeAnnouncement = () => {
    announcementObserver.disconnect();
    const announcement = document.querySelector(announcementSelector);
    if (announcement) announcementObserver.observe(announcement);
    updateAnnouncementHeight();
  };
  document.addEventListener('shopify:section:load', observeAnnouncement);
  document.addEventListener('shopify:section:unload', observeAnnouncement);
  observeAnnouncement();
  /** @type {number | null} */
  let raf = null;
  const update = () => {
    raf = null;
    header.classList.toggle('header--scrolled', window.scrollY > 10);
  };
  const onScroll = () => {
    if (raf !== null) return;
    raf = requestAnimationFrame(update);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
